import { STRAIGHT_MAN_CATEGORY } from '@/constants';

import { HARDCODED_CATEGORIES } from '../../OwnAIMan/constants';

import type { IdentifyOptionIdType } from '../types';

export interface IdentifyCategoriesResult {
  categories: string[];
  first_categories: string[];
}

export function getIdentifyCategories(
  gender: 'male' | 'female' | null,
  identify: IdentifyOptionIdType | null,
): IdentifyCategoriesResult | null {
  if (gender !== 'male') {
    return null;
  }

  if (!identify) {
    return null;
  }

  if (identify === 'male') {
    return {
      categories: HARDCODED_CATEGORIES,
      first_categories: HARDCODED_CATEGORIES,
    };
  }

  if (identify === 'female') {
    return {
      categories: [STRAIGHT_MAN_CATEGORY],
      first_categories: [STRAIGHT_MAN_CATEGORY],
    };
  }

  if (identify === 'other' || identify === 'prefer_not_to_say') {
    return {
      categories: [...HARDCODED_CATEGORIES, STRAIGHT_MAN_CATEGORY],
      first_categories: [...HARDCODED_CATEGORIES, STRAIGHT_MAN_CATEGORY],
    };
  }

  return null;
}
